/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Pipe, PipeTransform } from '@angular/core';
import { map$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';

function pickByPath(...properties: string[]): (value: unknown) => unknown {
  return (value: unknown) =>
    (properties as string[]).reduce((current: any, prop) => current?.[prop], value);
}

@Pipe({
  standalone: false, name: 'pluck$', pure: true })
export class Pluck$Pipe implements PipeTransform {
  transform(ob$?: Observable<any>, ...properties: string[]): any {
    if (!ob$) {
      return ob$;
    }

    return ob$.pipe(map$(pickByPath(...properties)));
  }
}
